module.exports = __webpack_public_path__ + "static/media/Sketch.7ab5c596.svg";